export default __webpack_public_path__ + "7e9202ce75f3efa41317f8c8179b773d.svg";